// This is file is only here to allow importing type namespace
// from JS.
export * from "./lib.js"
